/**
 * ParentalPinDialContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const ParentalPinDialContainer = styled.div<Props>`
  align-items: center;
  background: ${(props) =>
    props.focused ? Colors['modal']['dial']['background'] : ''};
  border: solid ${2 * Screen.widthRatio}px ${Colors['modal']['dial']['border']};
  color: ${Colors['light']};
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${120 * Screen.widthRatio}px;
  justify-content: center;
  margin: ${20 * Screen.widthRatio}px;
  height: ${184 * Screen.widthRatio}px;
  width: ${120 * Screen.widthRatio}px;
`;

export default ParentalPinDialContainer;
